// flow
import { useEffect, useRef } from 'react'
export default function useEventListener(
  eventName: string,
  handler: any,
  _element?: HTMLElement | Document | null | undefined,
) {
  // SLAM-1938: React 19 requires an initial value for useRef, so we pass undefined. This is valid on React 18 and does not change behaviour.
  const savedHandler = useRef<((event: Event) => void) | undefined>(undefined)
  useEffect(() => {
    savedHandler.current = handler
  }, [handler])
  useEffect(
    () => {
      // refer to `window` only in useEffect, because it's undefined on server
      const element = _element || window
      const isSupported = element && element.addEventListener
      if (!isSupported) return

      const eventListener = event => savedHandler.current(event)

      element.addEventListener(eventName, eventListener)
      return () => {
        element.removeEventListener(eventName, eventListener)
      }
    },
    [eventName, _element], // Re-run if eventName or element changes
  )
}
